'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _group = require('../base/group');

var _group2 = _interopRequireDefault(_group);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group = function (_BaseGroup) {
  (0, _inherits3.default)(Group, _BaseGroup);

  function Group(data) {
    (0, _classCallCheck3.default)(this, Group);
    return (0, _possibleConstructorReturn3.default)(this, (Group.__proto__ || (0, _getPrototypeOf2.default)(Group)).call(this, data));
  }

  (0, _createClass3.default)(Group, [{
    key: 'setLabelModel',
    value: function setLabelModel() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var Label = this.getLabelModel();
      this.labels = [];

      this.data.labels.forEach(function (l) {
        var label = (0, _util.create)(Label, l, 'LABEL');
        _this2.labels.push(label);
      });
      // this.data.giftPacks.forEach((l) => {
      //   console.log(l, 'gift')
      //   let label = create(Label, l, 'GIFT')

      //   this.labels.push(label)
      // })
    }
  }, {
    key: 'getPreviewPacks',
    value: function getPreviewPacks() {
      return this.data.packs.filter(function (pack) {
        return pack.p_checked || pack.benefit && pack.benefit.id && pack.benefit.isThreshold;
      });
    }
  }, {
    key: 'getPreview',
    value: function getPreview(packs) {
      var ids = (0, _util.cleanPacks)(packs);
      console.log('refresh preview', ids.map(function (el) {
        return el.id;
      }));
      return (0, _util.axios)({
        url: '/app/cart/preview',
        method: 'POST',
        json: ids
      });
    }
  }]);
  return Group;
}(_group2.default);

exports.default = Group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/mobile/group.js
// module id = 1169
// module chunks = 0